import {
  MessageType,
  SpaceSendMessageType,
  SystemSendMessageType,
  UserSendMessageType,
} from "@/resources/constants/graphicClient/graphicClient";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import { AuthService } from "@/services/auth/auth.service";
const _authService = new AuthService();

const initializeCityAction = ({ commit, rootGetters }, data) => {
  //const userJSON = rootGetters["UserStore/getUser"];
  const response = {
    superSpaces: data,
  };
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.INITIALIZE_CITY,
    response
  );
};

const initializeUserAndSpaceAction = ({ commit, rootGetters }) => {
  const spaceJSON = rootGetters["SpaceStore/getSpace"];
  const userJSON = rootGetters["UserStore/getSpaceUser"];
  
  const response = {
    user: userJSON,
    space: spaceJSON,
  };

  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.INITIALIZE_USER_AND_SPACE,
    response
  );
};

const initializeUserOnBoardingAction = ({ commit, rootGetters }) => {
  console.log("initializeUserOnBoardingAction");
  const spaceJSON = rootGetters["SpaceStore/getSpace"];
  const userJSON = rootGetters["UserStore/getSpaceUser"];

  const response = {
    user: userJSON,
    space: spaceJSON,
    spaceToLoadAfterTutorial: spaceJSON.scenario.scenarioType.name,
  };

  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.INITIALIZE_USER_ONBOARDING,
    response
  );
};

const spaceReadyAction = async ({ commit }, usersOnline): Promise<void> => {
  await GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.CONNECTED_USERS,
    usersOnline
  );
};

const connectedUser = ({ commit }, userSpace): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.USER_CONNECTED,
    userSpace
  );
};

const disconnectedUser = ({ commit }, userSpace): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.USER_DISCONNECTED,
    userSpace
  );
};

const updateUser = ({ commit }, userSpace): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.UPDATE_USER,
    userSpace
  );
};

const vacationOn = ({ commit }, userSpace): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.USER_VACATION_ON,
    userSpace
  );
};

const vacationOff = ({ commit }, userSpace): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.USER_VACATION_OFF,
    userSpace
  );
};

const disableUser = ({ commit }, userSpace): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.USER_DISABLE,
    userSpace
  );
};

const changeSpace = ({ commit }, space): void => {
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.CHANGE_SPACE,
    space
  );
};

const updateSpace = ({ commit }, space): void => {
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.UPDATE_SPACE,
    space
  );
};

const spaceDisable = ({ commit, rootGetters }, space): void => {
  const userJSON = rootGetters["UserStore/getSpaceUser"];
  if (!userJSON.isAdmin) {
    GraphicClient.sendMessage(
      MessageType.SPACE,
      SpaceSendMessageType.SPACE_DISABLED,
      space
    );
    _authService.logOut();
  }
};

const webinarActiveRoomCollider = ({ commit }, dataJSON): void => {
  const data = {
    roomId: dataJSON.roomId,
    active: dataJSON.active,
  };
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.WEBINAR_ACTIVE_ROOM_COLLIDER,
    data
  );
};

const callOneToOneOk = ({ commit }, userId): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.CALL_ONE_TO_ONE_OK,
    userId
  );
};

const setLabelToggleAction = ({ commit }, isVisible): void => {
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.LABEL_TOGGLE,
    isVisible
  );
};

const focusUserAction = ({ commit }, userId): void => {
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.FOCUS_USER,
    userId
  );
};

const resizeGraphicClientAction = ({ commit }): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.FORCE_RESIZE
  );
};

const sendPaperPlaneAction = ({ commit }, userId): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.SEND_PAPER_PLANE,
    userId
  );
};

const sendBirthdayCokeAction = ({ commit }, userId): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.SEND_BIRTHDAY_COKE,
    userId
  );
};

const roomUpdateAction = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.UPDATE_ROOM,
    data
  );
};

const posterUpdateAction = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.UPDATE_POSTER,
    data
  );
};

const exitNubiiAction = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.EXIT_NUBII
  );
};

const setZoom = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.SET_ZOOM,
    data
  );
};

const moveCamera = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.SET_MOVE_CAMERA,
    data
  );
};

const rotationCamera = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.SET_ROTATIOM_CAMERA,
    data
  );
};

const beginTutorial = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.BEGIN_TUTORIAL
  );
};

const updateUserPosition = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.UPDATE_USER_POSITION,
    data
  );
};

const updateUserPositionByRoom = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.UPDATE_POSITION_BY_ROOM,
    data
  );
};

const emojiReaction = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.USER,
    UserSendMessageType.EMOJI_REACTION,
    data
  );
};

const updateMultiWebinar = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.UPDATE_MULTI_WEBINAR,
    data
  );
};

const inTheSpace = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SYSTEM,
    SystemSendMessageType.IN_THE_ROOM,
    data
  );
};

const wallsUpdateAction = ({ commit }, data): void => {
  GraphicClient.sendMessage(
    MessageType.SPACE,
    SpaceSendMessageType.UPDATE_WALLS,
    data
  );
};

export default {
  initializeUserAndSpaceAction,
  initializeUserOnBoardingAction,
  spaceReadyAction,
  connectedUser,
  disconnectedUser,
  updateUser,
  vacationOn,
  vacationOff,
  disableUser,
  changeSpace,
  updateSpace,
  spaceDisable,
  webinarActiveRoomCollider,
  callOneToOneOk,
  setLabelToggleAction,
  focusUserAction,
  resizeGraphicClientAction,
  sendPaperPlaneAction,
  roomUpdateAction,
  exitNubiiAction,
  setZoom,
  moveCamera,
  rotationCamera,
  beginTutorial,
  updateUserPosition,
  emojiReaction,
  initializeCityAction,
  updateMultiWebinar,
  posterUpdateAction,
  updateUserPositionByRoom,
  sendBirthdayCokeAction,
  inTheSpace,
  wallsUpdateAction,
};
